<template>
    <CRow>
        <CDataTable
            class="col-12 px-0"
            :items="Object.values(campaigns)"
            :fields="$dataTableFieldsMaker(fields)"
            hover
            :pagination="{ ...pagination, change: fetchCampaigns }"
            addTableClasses="bg-white"
        >
            <template #name="{item}">
                <td>{{ item.name }}<span class="badge badge-info" v-if="item.system_generated">سیستمی</span></td>
            </template>

            <template #status="{item}">
                <td v-if="$policy('campaign', item).edit_any_or_group">
                    <CSelect
                        class="mb-0 px-0 py-1"
                        :options="campaignStatusOption"
                        @update:value="value => changeStatus({ id: item.id, status: value }).then(() => item.status_input_class = inputClass(value))"
                        :value="item.status"
                        :addInputClasses="'px-1 font-xs ' + (item.status_input_class ? item.status_input_class : inputClass(item.status))"
                    />
                </td>
                <td v-else>
                    <span class="badge" :class="'badge-'+statusColor(item.status)">{{ statusStr(item.status) }}</span>
                </td>
            </template>

            <template #storeName="{item}">
                <td>
                    {{ item.store ? item.store.name : '-' }}
                </td>
            </template>

            <template #cost="{item}">
                <td>
                    {{ item.cost ? $commas(item.cost) : '-' }}
                </td>
            </template>

            <template #plan="{item}">
                <td>{{ item.plan ? planStr(item.plan.key) : '-' }}</td>
            </template>

            <template #goal="{item}">
                <td>{{ goalStr(item.goal) }}</td>
            </template>

            <template #startedAt="{item}">
                <td class="small" v-if="$policy('campaign', item).edit_any_or_group">
                    <datePicker
                        :placeholder="$t('campaign.started_at')"
                        :clearable="true"
                        format="YYYY-MM-DD HH:mm:ss"
                        display-format="dddd jDD jMMMM jYYYY"
                        input-class="form-control small"
                        type="datetime"
                        @change="$event => edit({id: item.id, started_at: $event ? $event.format('YYYY-MM-DD HH:mm:ss') : null}).then(notifStartedAtUpdated())"
                        v-model="item.started_at"
                    />
                </td>
                <td v-else>{{ item.started_at ? $moment(item.started_at).format('LLL') : $t('not_setted') }}</td>
            </template>

            <template #finishedAt="{item}">
                <td class="small" v-if="$policy('campaign', item).edit_any_or_group">
                    <datePicker
                        :placeholder="$t('campaign.finished_at')"
                        :clearable="true"
                        format="YYYY-MM-DD HH:mm:ss"
                        display-format="dddd jDD jMMMM jYYYY"
                        input-class="form-control small"
                        type="datetime"
                        @change="$event => edit({id: item.id, finished_at: $event ? $event.format('YYYY-MM-DD HH:mm:ss') : null}).then(notifFinishedAtUpdated())"
                        v-model="item.finished_at"
                    />
                </td>
                <td v-else>{{ item.finished_at ? $moment(item.finished_at).format('LLL') : $t('not_setted') }}</td>
            </template>

            <template #actions="{item}">
                <td>
                    <CLink v-if="$policy('campaign', item).edit && (!item.system_generated || $policy('campaign', item).edit_any_or_group)"
                        :disabled="[CampaignStatus.RUNNING, CampaignStatus.COMPLETED, CampaignStatus.CANCELLED].includes(item.status)"
                        :class="{'text-muted outline-none': item.is_closed, 'text-dark': [CampaignStatus.RUNNING, CampaignStatus.COMPLETED, CampaignStatus.CANCELLED].includes(item.status)}"
                        :to="{name: 'campaigns.edit', params: {id: item.id}}"
                    >
                        <FaIcon icon="edit" />
                    </CLink>
                </td>
            </template>
        </CDataTable>
    </CRow>
</template>

<script>
import fields from './fields'
import { planStr, goalStr, statusStr, statusColor } from './methods'
import { mapGetters, mapActions } from 'vuex'
import { CampaignStatus } from '@/constants'
import { campaignStatusOption } from '@/common/data'

export default {
    name: 'List',

    components: {
        //
    },

    data() {
        return {
            CampaignStatus,
            campaignStatusOption,
            fields,
        }
    },

    computed: {
        ...mapGetters({
            campaigns: 'campaign/campaigns',
            pagination: 'campaign/pagination',
            filterMeFields: 'filterMeComponent/filterMeFields',
        }),
    },

    methods: {
        planStr,
        goalStr,
        statusStr,
        statusColor,
        ...mapActions({
            fetch: 'campaign/fetch',
            changeStatus: 'campaign/changeStatus',
            edit: 'campaign/edit',
            // setMsg: 'messageComponent/setMsg',
            // resetMsg: 'messageComponent/resetMsg',
            setCToast: 'toastComponent/setCToast',
            // setShowLoading: 'loadingComponent/setShowLoading',
        }),
        fetchCampaigns(activePage, params = false) {
            this.fetch({
                page: activePage,
                ...params,
                ...this.filterMeFields
            })

            this.pagination.page = activePage
        },
        inputClass(status) {
            const obj = campaignStatusOption.find(obj => obj.value === status)

            return obj.style
        },
        notifStartedAtUpdated() {
            this.setCToast({
                msg: 'تاریخ شروع کمپین بروزرسانی شد',
                class: 'bg-success text-white'
            })
        },
        notifFinishedAtUpdated() {
            this.setCToast({
                msg: 'تاریخ پایان کمپین بروزرسانی شد',
                class: 'bg-success text-white'
            })
        }
    },
}
</script>